<template><div></div></template>

<script>
import L from "leaflet";
// import distToSegment from "@/util/distToSegment.js";
export default {
  props: ["map", "options", "value"],
  data() {
    return {
      name: "PolygonMap",
      polygons: [],
      editingPolygonId: null,
      is_active: true,
      iconCenter: [],
      markers: [],
      popup: [],
      customIconCenter: null,
      customIcon: null,
      editLatLng: false,
      vertexIdCounter: 0,
      center: null,
      centerMarkerEditPolygon: null,
    };
  },
  methods: {
    show() {
      if (this.is_active) {
        this.options.forEach((e) => {
          if (e.lat !== null && e.polygon !== null) {
            this.polygons = this.options.map((option) => ({
              ...option,
              polygonObject: null,
              editing: false,
              vertices: option.polygon.map((coords) => ({
                id: ++this.vertexIdCounter,
                coords, // [lat, lng]
              })),
              center: [option.lat, option.lng],
              editLatLng: false,
            }));
          }
        });
        this.customIconCenter = L.divIcon({
          className: "custom-marker",
          html: '<div style="border: 2px solid black; border-radius: 50%; width: 13px; height: 13px;"><div style="border: 1px solid black; border-radius: 50%; width: 5px; height: 5px; margin: 2px; background-color: black;"></div></div>',
          iconSize: [10, 10],
          iconAnchor: [10, 10],
        });
        this.customIcon = L.divIcon({
          className: "custom-marker",
          html: '<div style="background-color: #ffff; width: 15px; height: 15px; border-radius: 10%; border: 2px solid black;"></div>',
          iconSize: [10, 10],
          iconAnchor: [10, 10],
        });
        this.initMap();
        this.is_active = false;
      }
    },
    initMap() {
      this.createPolygons();
    },
    populCursor(e, id) {
      this.clearMarkerPopul();
      if (e) {
        this.polygons.forEach((poly) => {
          if (id == poly.id) {
            if (!poly.editing) {
              this.createCenterMarker(id);
              let popup = L.popup()
                .setLatLng([e.latlng.lat, e.latlng.lng])
                .setContent(
                  `<p>Район: ${poly.id}<br />Название: ${poly.name}<br/>Зона: ${poly.group}</p>`
                )
                .openOn(this.map);

              this.popup.push(popup);
            }
          }
        });
      }
    },
    createCenterMarker(id) {
      this.clearMarkerPopul();
      this.polygons.forEach((poly) => {
        if (id == poly.id) {
          const iconCenter = L.marker(poly.center, {
            icon: this.customIconCenter,
          }).addTo(this.map);

          this.iconCenter.push(iconCenter);
        }
      });
    },
    centerMarkerEdit(poly) {
      const centerMarkerEditPolygon = L.marker(poly.center, {
        icon: this.customIconCenter,
        draggable: true,
      })
        .addTo(this.map)
        .on("dragend", (e) => {
          this.center = e.target._latlng;
          this.polygons.map((p) => {
            if (p.editing) this.emitPoly(p);
          });
        });

      this.centerMarkerEditPolygon = centerMarkerEditPolygon;
    },
    createPolygons() {
      this.polygons.forEach((poly) => {
        if (poly.center.length > 0 && poly.vertices.length > 0) {
          const polygon = L.polygon(
            poly.vertices.map((v) => v.coords),
            {
              color: "black",
              fillColor: poly.color,
              fillOpacity: 0.6,
            }
          ).addTo(this.map);

          polygon.on("click", () => this.enableEditing(poly.id));
          polygon.on("mouseover", (e) => this.populCursor(e, poly.id));
          polygon.on("mouseout", () => this.clearMarkerPopul());
          polygon.on("click", (e) => this.onPolygonBorderClick(e));
          poly.polygonObject = polygon;
        }
      });
    },
    clearPolygon() {
      this.polygons.forEach((e) => {
        if (e.polygonObject) {
          e.polygonObject.remove();
        }
      });
      this.allRemoveMarker();
      this.clearMarkerPopul();
      this.removeCenterMarker();
      this.clearData();
      this.editLatLng = false;
    },
    enableEditing(polygonId) {
      if (
        this.editingPolygonId !== null &&
        this.editingPolygonId !== polygonId
      ) {
        if (polygonId !== this.editingPolygonId) {
          console.log(polygonId, this.editingPolygonId, this.editLatLng);
          // this.disableEditing();
          if (this.editLatLng) {
            let status = confirm(
              "Все несохранённые данные будут потеряны. Отменить изменения?"
            );
            if (status) {
              this.clearPolygon();
              this.is_active = true;
              this.show();
              this.disableEditing();
            } else {
              return;
            }
          }
        }
      }

      const poly = this.polygons.find((p) => p.id === polygonId);

      if (!poly) return;
      if (this.centerMarkerEditPolygon) this.centerMarkerEditPolygon.remove();
      this.centerMarkerEdit(poly);

      this.editingPolygonId = polygonId;
      poly.editing = true;

      this.$emit("open", polygonId);

      // this.createPolygons(polygonId, 'blue')

      this.allRemoveMarker();

      poly.vertices.forEach((v) => {
        const m = L.marker(v.coords, {
          draggable: true,
          icon: this.customIcon,
        }).addTo(this.map);
        m._vertexId = v.id; // ← привязываем id вершины к самому маркеру
        this.markers.push(m);

        m.on("click", () => this.removeMarker(poly.id, v.id));

        m.on("drag", (e) => {
          this.editLatLng = true;
          const p = e.target.getLatLng();
          v.coords = [p.lat, p.lng];
          poly.polygonObject.setLatLngs(poly.vertices.map((vv) => vv.coords));
          this.emitPoly(poly);
        });
      });
    },
    disableEditing() {
      if (this.editingPolygonId === null) return;

      const polygon = this.polygons.find((p) => p.id === this.editingPolygonId);
      if (!polygon) return;

      polygon.editing = false;
      this.allRemoveMarker();
      this.editingPolygonId = null;
    },
    // onPolygonBorderClick(e) {
    //     if(this.editingPolygonId === null) return

    //   console.log(e);

    //   //   if (this.editingPolygonId === null) return;
    //   //   if (this.editLatLng) {
    //   //     const polygon = this.polygons.find(
    //   //       (p) => p.id === this.editingPolygonId
    //   //     );
    //   //     if (!polygon) return;

    //   //     polygon.vertices.push([e.latlng.lat, e.latlng.lng]);
    //   //     this.enableEditing(polygon.id);
    //   //   }
    // },
    distToSegment(p, p1, p2) {
      const x = p.x;
      const y = p.y;
      const x1 = p1.x;
      const y1 = p1.y;
      const x2 = p2.x;
      const y2 = p2.y;

      const A = x - x1;
      const B = y - y1;
      const C = x2 - x1;
      const D = y2 - y1;

      const dot = A * C + B * D;
      const len_sq = C * C + D * D;
      let param = -1;
      if (len_sq !== 0) param = dot / len_sq;

      let xx, yy;
      if (param < 0) {
        xx = x1;
        yy = y1;
      } else if (param > 1) {
        xx = x2;
        yy = y2;
      } else {
        xx = x1 + param * C;
        yy = y1 + param * D;
      }

      const dx = x - xx;
      const dy = y - yy;
      return Math.sqrt(dx * dx + dy * dy);
    },
    onPolygonBorderClick(e) {
      if (this.editingPolygonId === null) return;
      const poly = this.polygons.find((p) => p.id === this.editingPolygonId);
      if (!poly) return;

      const pts = poly.vertices.map((v) => v.coords);
      const clickPt = this.map.latLngToLayerPoint(e.latlng);
      let nearestSeg = -1,
        min = Infinity;

      pts.forEach((c, i) => {
        const p1 = this.map.latLngToLayerPoint(L.latLng(c));
        const p2 = this.map.latLngToLayerPoint(
          L.latLng(pts[(i + 1) % pts.length])
        );
        const d = this.distToSegment(clickPt, p1, p2);
        if (d < min) {
          min = d;
          nearestSeg = i;
        }
      });

      if (min > 8) return; // курсор далеко от границы – ничего не делаем

      // создаём новую вершину
      const newVertex = {
        id: ++this.vertexIdCounter,
        coords: [e.latlng.lat, e.latlng.lng],
      };
      const insertAt = nearestSeg + 1;
      poly.vertices.splice(insertAt, 0, newVertex);
      poly.polygonObject.setLatLngs(poly.vertices.map((v) => v.coords));

      const m = L.marker(e.latlng, {
        draggable: true,
        icon: this.customIcon,
      }).addTo(this.map);

      m._vertexId = newVertex.id;
      this.markers.splice(insertAt, 0, m);

      m.on("click", () => this.removeMarker(poly.id, newVertex.id));
      m.on("drag", (ev) => {
        const p = ev.target.getLatLng();
        newVertex.coords = [p.lat, p.lng];
        poly.polygonObject.setLatLngs(poly.vertices.map((v) => v.coords));
        this.emitPoly(poly);
      });

      this.emitPoly(poly);
      this.editLatLng = true;
    },
    removeMarker(polygonId, vertexId) {
      if (this.editingPolygonId !== polygonId) return;
      const poly = this.polygons.find((p) => p.id === polygonId);
      if (!poly) return;

      // убираем вершину
      const idx = poly.vertices.findIndex((v) => v.id === vertexId);
      if (idx === -1) return;
      poly.vertices.splice(idx, 1);

      // убираем маркер
      const mIdx = this.markers.findIndex((m) => m._vertexId === vertexId);
      if (mIdx !== -1) {
        this.markers[mIdx].remove();
        this.markers.splice(mIdx, 1);
      }

      poly.polygonObject.setLatLngs(poly.vertices.map((v) => v.coords));
      this.emitPoly(poly);
    },
    emitPoly(poly) {
      this.$emit("input", {
        id: poly.id,
        polygon: poly.vertices.map((v) => v.coords),
        center: this.center || poly.center,
      });
    },
    allRemoveMarker() {
      this.markers.forEach((marker) => {
        if (marker) {
          marker.remove();
          this.markers = [];
        }
      });
    },
    removeCenterMarker() {
      if (this.centerMarkerEditPolygon) {
        this.centerMarkerEditPolygon.remove();
        this.centerMarkerEditPolygon = null;
      }
    },
    clearMarkerPopul() {
      if (this.popup) this.popup.forEach((icon) => icon.remove());
      this.popup = [];
      if (this.iconCenter) this.iconCenter.forEach((icon) => icon.remove());
      this.iconCenter = [];
    },
    clearData() {
      (this.polygons = []),
        (this.editingPolygonId = null),
        (this.is_active = true),
        (this.iconCenter = []),
        (this.markers = []),
        (this.popup = []),
        (this.customIconCenter = null),
        (this.customIcon = null),
        (this.vertexIdCounter = 0),
        (this.center = null),
        (this.centerMarkerEditPolygon = null);
    },
    cancelPolygon() {
      this.removeCenterMarker();
      this.allRemoveMarker();
    },
  },
};
</script>

<style scoped>
.custom-marker {
  background-color: #ffff;
  width: 10px;
  height: 10px;
  border-radius: 10%;
  border: 2px solid black;
}
</style>
